/**
 * Load fonts Mackinac (serif) and Noto Sans (body sans)
 */
import 'static/fonts/mackinac.css';
import 'static/fonts/notoSans.css';

import { Environment, getEnvironment, initMonitoring } from '@color/lib';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';

import { loadPolyfills } from 'lib/polyfills/loadPolyfills';
import { getMonitoringConfig } from 'lib/util/monitoring/config';

import { BaseApp } from './ui/App/BaseApp';

const environment: Environment = getEnvironment();
initMonitoring(getMonitoringConfig(environment));

export async function initializeReactApp() {
  await loadPolyfills();
  const ConfiguredBaseApp = await BaseApp();
  ReactDOM.render(
    <StrictMode>
      <ConfiguredBaseApp />
    </StrictMode>,
    document.getElementById('root') as HTMLElement
  );
}
